import { cssVar, defineStyleConfig } from "@chakra-ui/react";

const baseStyle = {
  backgroundColor: "gray.50",
  color: "black",
  maxWidth: "100px",
  [cssVar("popper-arrow-bg").variable]: "#DBDBDB",
};

const tooltipTheme = defineStyleConfig({
  baseStyle,
});

export default tooltipTheme;
